var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.report ? _c('v-simple-table', [_c('tbody', _vm._l(_vm.items, function (item, idx) {
    return _c('tr', {
      key: idx
    }, [_c('td', [_vm._v(_vm._s(item.text))]), _c('td', [_vm._v(_vm._s(item.value))])]);
  }), 0)]) : _vm._e(), _vm.hasDamageLocation ? _c('v-card', {
    staticClass: "ma-auto pt-4",
    attrs: {
      "flat": "",
      "width": _vm.getDamageLocatorWidth,
      "min-width": _vm.getDamageLocatorWidth,
      "max-height": _vm.getDamageLocatorHeight
    }
  }, [_vm.renderComponent ? _c('damage-locator-combined', {
    ref: "DamageLocator",
    attrs: {
      "isEdit": false,
      "reportType": _vm.reportType,
      "clickedColor": _vm.color,
      "damage-locations": _vm.damageLocation
    },
    on: {
      "damageLocation": _vm.forceRerender
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.hasImages ? _c('partner-report-detail-image-time-line-element', {
    staticClass: "mt-4",
    attrs: {
      "images": _vm.images
    }
  }) : _vm._e(), _vm.hasDocuments ? _c('v-card', {
    staticClass: "mt-4",
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pb-2"
  }, [_vm._v(" " + _vm._s(_vm.$t("report.user.MyDamageDetail.documents")) + " "), _c('v-chip', {
    staticClass: "ml-2",
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_vm._v(_vm._s(_vm.documentCount))]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "x-small": "",
      "dense": "",
      "color": "info"
    },
    on: {
      "click": _vm.downloadAllDocuments
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("common.verbs.download")) + " ")])], 1), _c('v-divider'), _c('v-list', {
    staticClass: "py-0"
  }, _vm._l(_vm.report.documents, function (document) {
    return _c('v-list-item', {
      key: 'document-' + document.id,
      on: {
        "click": function click($event) {
          return _vm.openInNewTab(document);
        }
      }
    }, [_c('v-list-item-content', {
      staticClass: "py-2"
    }, [_c('v-list-item-title', [_vm._v(" " + _vm._s(document.title || document.name) + " ")]), document.description ? _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(document.description) + " ")]) : _vm._e()], 1), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.downloadDocument(document);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-download")])], 1)], 1)], 1);
  }), 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }